{
  "version": 1,
  "asset_id": "6cf5df31-58c1-4f7b-b473-b3bb953f2a61",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/6cf5df31-58c1-4f7b-b473-b3bb953f2a61/hero-new-480.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/6cf5df31-58c1-4f7b-b473-b3bb953f2a61/hero-new-480.webp",
  "original_filename": "hero-new-480.webp",
  "size": 11594,
  "content_type": "image/webp",
  "created_at": "2026-08-02T03:39:02Z"
}
